<template>
  <div>
    <h3>基本信息</h3>
    <avue-form
      v-model="form"
      ref="form"
      v-if="show || model == 'add'"
      :option="addFormOption"
      @submit="handleSubmit"
    >
      <template slot="map">
        <div>
          <BaiduMap
            :keyword="form.addr"
            :lat.sync="form.locationLatitude"
            :lng.sync="form.locationLongitude"
            :disabled="passCloseDialog"
          >
          </BaiduMap>
        </div>
      </template>
      <template slot="content">
        <VueEditor
          id="editor"
          v-model="form.content"
          useCustomImageHandler
          @image-added="handleImageAdded"
        ></VueEditor>
      </template>
    </avue-form>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import BaiduMap from '..//map/baiduMap.vue';
import { putFile } from '@/api/crmedical/contract/add';
import { add, update } from '@/api/v4ward/carv2/carparkspace';
export default {
  components: { VueEditor, BaiduMap },
  props: ['model', 'parkSpace'],
  data() {
    return {
      show: false,
      passCloseDialog: false,
      form: {
        addr: '',
        locationLongitude: '',
        locationLatitude: '',
      },
      next: false,
      addFormOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 100,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            search: true,
            showWordLimit: true,
            maxlength: 20,
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '编号',
            prop: 'spaceCode',
            span: 12,
            showWordLimit: true,
            maxlength: 32,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入编号',
                trigger: 'change',
              },
              {
                pattern: /^[a-zA-Z][a-zA-Z0-9]{5,31}$/,
                message: '编号只能包含字母和数字,且以字母开头,长度6-32',
              },
            ],
          },
          {
            label: '道闸品牌',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_brand',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'equType',
            rules: [
              {
                required: true,
                message: '请输入道闸品牌',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'IOT网关ID',
            prop: 'iotGatewayId',
            hide: true,
            display:true,
            showWordLimit: true,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: '请输入IOT网关ID',
                trigger: 'change',
              },
              { pattern: /^[^\u4e00-\u9fa5]+$/, message: '格式错误' },
            ],
          },
          {
            label: '所属部门',
            type: 'tree',
            span: 12,
            dicUrl: '/api/base/deptproperty/tree',
            prop: 'deptId',
            props: {
              label: 'title',
              value: 'value',
              children: 'children',
            },
            rules: [
              {
                required: true,
                message: '请输入部门名',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属小区',
            type: 'tree',
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
            props: {
              label: 'title',
              value: 'id',
            },
            prop: 'areaId',
            rules: [
              {
                required: true,
                message: '请选择所属小区',
              },
            ],
          },
          {
            label: '状态',
            prop: 'clientStatus',
            display: false,
            width: 80,
            slot: true,
            editDisabled: true,
            addDisabled: true,
          },
          {
            label: '车场排序',
            prop: 'sort',
            width: 80,
            hide: true,
            maxlength: 9,

            rules: [
              {
                required: false,
                message: '请输入车场排序字段',
                trigger: 'change',
              },
              { pattern: /^[+]?\d{1,6}$/, message: '格式错误' },
            ],
          },
          {
            label: '车场位置',
            prop: 'addr',
            overHidden: true,
            span: 24,
            showWordLimit: true,
            maxlength: 150,
            rules: [
              {
                required: true,
                message: '请输入车场位置',
                trigger: 'change',
              },
            ],
          },
          {
            label: '',
            prop: 'map',
            span: 24,
            hide: true,
            formslot: true,
          },
          {
            label: '经度',
            prop: 'locationLongitude',
            disabled: true,
            span: 12,
          },
          {
            label: '纬度',
            prop: 'locationLatitude',
            disabled: true,
            span: 12,
          },
          {
            label: '收费规则',
            prop: 'content',
            hide: true,
            row: true,
            span: 24,
            maxlength: 2000,
            required: true,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请填写收费规则',
                trigger: 'change',
              },
              { max: 2000, message: '请控制在2000个字符内', trigger: 'change' },
            ],
          },
        ],
      },
    };
  },
  watch: {
    "form.equType"(){
      if (this.form.equType == 7 || this.form.equType == 8) {
        this.addFormOption.column[3].display = false;
        this.addFormOption.iotGatewayId = '';
      }else{
        this.addFormOption.column[3].display = true;
        this.addFormOption.iotGatewayId = '';
      }
    },
  },
  methods: {
    setDefaultForm(data) {
      this.addFormOption.column[0].disabled = true;
      this.addFormOption.column[1].disabled = true;
      this.form = data;
      this.show = true;
    },
    handleSubmit(form, done) {
      console.log(this.form);
      if (this.model == 'add' && !form.id) {
        add(form).then(
          (res) => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            done();
            this.form.id = res.data.id;
            this.form.type = res.data.type;
            this.form.tenantId = res.data.tenantId;
            this.$emit('getNewSpaceDetails', res.data);
            this.$emit('getQuestionResult', this.next);
          },
          (error) => {
            this.$emit('getQuestionResult', false);
            done();
            console.log(error);
          }
        );
      } else {
        update(form).then(
          (res) => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            done();
            // this.$emit('getNewSpaceDetails',res.data)
            this.$emit('getQuestionResult', this.next);
          },
          (error) => {
            this.$emit('getQuestionResult', false);
            done();
            console.log(error);
          }
        );
      }
    },
    formSubmit(next) {
      if (next) {
        this.next = next;
        // if(this.parkSpace.id){
        //         this.$emit('getQuestionResult',this.next)
        // }else{
        //         this.$refs.form.submit();
        // }
      } else {
        this.next = false;
        // this.$refs.form.submit();
      }
      this.$refs.form.submit();
      // this.$emit('getQuestionResult',this.next)
    },
    // 富文本处理图片上传问题
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      if (this.VueEditorDisabled) {
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
